export default "<!-- Registered actions render in the owning view-modes-section header. -->\r\n";